var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-toast',{attrs:{"id":_vm.toastId,"variant":_vm.variant,"header-class":"hide","body-class":_vm.toastBodyClass,"toaster":"b-toaster-top-right"}},[_c('div',{staticClass:"content"},[_c('div',{class:_vm.iconBgClass},[_c('i',{class:_vm.icon})]),_c('p',{staticClass:"m-0"},[_vm._v(_vm._s(_vm.message))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }